/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Suggestion_DeliveryInputs */

const en_chat_suggestion_delivery = /** @type {(inputs: Chat_Suggestion_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deliver something between dispenser and ingestor`)
};

const fr_chat_suggestion_delivery = /** @type {(inputs: Chat_Suggestion_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Délivre quelque chose entre dispenser et ingestor`)
};

const ms_sg2_chat_suggestion_delivery = /** @type {(inputs: Chat_Suggestion_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantar sesuatu antara dispenser dan ingestor`)
};

/**
* | output |
* | --- |
* | "Deliver something between dispenser and ingestor" |
*
* @param {Chat_Suggestion_DeliveryInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_suggestion_delivery = /** @type {((inputs?: Chat_Suggestion_DeliveryInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestion_DeliveryInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_suggestion_delivery(inputs)
	if (locale === "fr") return fr_chat_suggestion_delivery(inputs)
	return ms_sg2_chat_suggestion_delivery(inputs)
});